import { render, staticRenderFns } from "./CalendarBox.vue?vue&type=template&id=b64668f4&scoped=true"
import script from "./CalendarBox.vue?vue&type=script&lang=js"
export * from "./CalendarBox.vue?vue&type=script&lang=js"
import style0 from "./CalendarBox.vue?vue&type=style&index=0&id=b64668f4&prod&lang=css"
import style1 from "./CalendarBox.vue?vue&type=style&index=1&id=b64668f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64668f4",
  null
  
)

export default component.exports